module.exports = __webpack_public_path__ + "images/8c398d70.png";